import { httpCreate } from './http';

const http = httpCreate('/srv/gather-mob-phone-white');

export const gatherMobPhoneWhite = {
	// 单独新增白名单
	addPhoneWhite(gatherId, params) {
		return http.post(`/single/${gatherId}`, params);
	},
	// 已使用列表
	usedWhiteList(gatherId, params) {
		return http.get(
			`/list/used/${gatherId}?pageNum=${params.pageNum}&pageSize=${params.pageSize}&searchText=${params.searchText}`,
		);
	},
	// 未使用列表
	unUsedWhiteList(gatherId, params) {
		return http.get(
			`/list/unUsed/${gatherId}?pageNum=${params.pageNum}&pageSize=${params.pageSize}&searchText=${params.searchText}`,
		);
	},
	// 删除白名单
	deletePhoneWhite(gatherId, isUsed, whiteListIds) {
		return http.delete(`/delete/${gatherId}/${isUsed}`, { data: whiteListIds });
	},
	// 导入名单
	importPhoneWhite(gatherId, data) {
		return http.post(`/import/${gatherId}`, data);
	},
	// 清空未使用
	clearUnusedPhone(gatherId) {
		return http.delete(`/clear/unUsed/${gatherId}`);
	},
	// 清空已使用
	clearUsedPhone(gatherId) {
		return http.delete(`/clear/usedClear/${gatherId}`);
	},
};
